'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.users = void 0;
var tslib_1 = require("tslib");
var adapter_1 = require("../adapter");
var session_1 = require("../session/session");
var getAmlVerificationStatus_1 = require("../adapter/users/getAmlVerificationStatus");
var userPendingConsents_1 = require("../adapter/users/userPendingConsents");
var util_1 = require("../util");
var util_2 = require("./util");
var transport_1 = require("../transport");
var API_ERRORS = {
    INVALID_VERIFICATION_CODE: 'INVALID_VERIFICATION_CODE',
};
var Users = /** @class */ (function () {
    function Users() {
    }
    /**
     * Adds a note to the users profile.
     */
    Users.prototype.addNote = function (note) {
        return adapter_1.adapter.users.addNote({ note: note });
    };
    /**
     * Saves a note to the user profile for CoreX
     */
    Users.prototype.acknowledgeMessage = function (params) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, adapter_1.adapter.users.acknowledgeMessage(params)];
            });
        });
    };
    /**
     * Get bankid iframe details
     */
    Users.prototype.getBankIdiFrameDetails = function (params) {
        return adapter_1.adapter.users.getBankIdiFrameDetails(params);
    };
    /**
     * Get sportnco sportsbook iframe url
     */
    Users.prototype.getSportncoLaunchURL = function (params) {
        return adapter_1.adapter.users.getSportncoLaunchURL(params);
    };
    /**
     * Get sportnco sportsbook demo iframe url
     */
    Users.prototype.getSportncoDemoLaunchURL = function (params) {
        return adapter_1.adapter.users.getSportncoDemoLaunchURL(params);
    };
    /**
     * Get sportnco sportsbook iframe url
     */
    Users.prototype.getSportncoLaunchURLCoreX = function (params) {
        return adapter_1.adapter.users.getSportncoLaunchURLCoreX(params);
    };
    /**
     * Get user profile
     */
    Users.prototype.getProfile = function () {
        return adapter_1.adapter.users.getProfile();
    };
    /**
     * Get user profileV2
     */
    Users.prototype.getProfileV2 = function () {
        return adapter_1.adapter.users.getProfileV2();
    };
    /**
     * Updates the users profile.
     */
    Users.prototype.updateProfile = function (profile) {
        return adapter_1.adapter.users.updateProfile(profile);
    };
    /**
     * Updates the users profile V2.
     */
    Users.prototype.updateProfileV2 = function (profile) {
        return adapter_1.adapter.users.updateProfileV2(profile);
    };
    /**
     * Trigger KYC verifications request
     */
    Users.prototype.triggerKYCVerificationsRequest = function (params) {
        return adapter_1.adapter.users.triggerKYCVerificationsRequest(params);
    };
    /**
     * User agrees with compliance (used within the wallet - cashier).
     */
    Users.prototype.agreedCompliance = function (username) {
        var user = session_1.session.getUser();
        if (!user && !username) {
            throw new Error('User not logged in or no userId given to agreedCompliance call.');
        }
        var params = { userName: username || user.userName };
        return adapter_1.adapter.users.agreedCompliance(params);
    };
    /**
     * Gets the available registration countries and the geo-located country
     * of the user based on their IP.
     */
    Users.prototype.getCountries = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var countries;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, adapter_1.adapter.users.getCountries()];
                    case 1:
                        countries = _a.sent();
                        countries.countries = countries.countries
                            // remove null countries
                            .filter(function (country) { return !!country; })
                            // sort by name ascending
                            .sort(function (a, b) { return a.name.localeCompare(b.name); });
                        countries.countries = countries.countries.filter(function (country, i) {
                            return i === 0 || countries.countries[i - 1].code !== country.code;
                        });
                        return [2 /*return*/, countries];
                }
            });
        });
    };
    /**
     * Login
     */
    Users.prototype.login = function (username, pwd) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var params, user;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = {
                            usernameOrEmail: username,
                            password: pwd,
                        };
                        return [4 /*yield*/, adapter_1.adapter.users.login(params)];
                    case 1:
                        user = _a.sent();
                        session_1.session.create(user);
                        this.subscribeForTags(user);
                        return [2 /*return*/, user];
                }
            });
        });
    };
    /**
     * Logs the user out
     */
    Users.prototype.logout = function () {
        var response = adapter_1.adapter.users.logout();
        // Destroy session after making the call to ensure the
        // call has access to the session ID still.
        session_1.session.destroy();
        return response;
    };
    /**
     * LoginV2 supports 2FA authentication
     *
     * @param username
     * @param pwd
     * @param [lang]
     * @param [oneTimePassword]
     * @param [geoResponse] Geo Comply response in case the brand has Geo Comply enabled
     */
    Users.prototype.loginV2 = function (username, pwd, lang, oneTimePassword, geoResponse) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var params, user;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = {
                            usernameOrEmail: username,
                            password: pwd,
                            lang: lang,
                            oneTimePassword: oneTimePassword,
                            geoResponse: geoResponse,
                        };
                        return [4 /*yield*/, adapter_1.adapter.users.loginV2(params)];
                    case 1:
                        user = _a.sent();
                        session_1.session.create(user);
                        this.subscribeForTags(user);
                        return [2 /*return*/, user];
                }
            });
        });
    };
    /**
     * gets the sportnco token
     */
    Users.prototype.getSportncoToken = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, adapter_1.adapter.users.getSportncoToken()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Authenticates the user with a one time only authentication token. If the
     * user is succesfuly authenticated, it returns the same user object as a regular
     * login call with an extra field, `isCompleted`, which indicates if we need
     * to collect some extra information from the user.
     *
     * @param token - One time authentication challenge token
     * @param [userId] - User ID being authenticated. Used for migration purposes.
     * @param [fromUserId] - Previous user ID related to the user
     *                                being authenticated. Used for migration purposes.
     */
    Users.prototype.authenticateWithChallengeToken = function (token, userId, fromUserId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var user;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, adapter_1.adapter.users.authenticateWithChallengeToken({
                            challengeToken: token,
                            userId: userId,
                            fromUserId: fromUserId,
                        })];
                    case 1:
                        user = _a.sent();
                        session_1.session.create(user);
                        this.subscribeForTags(user);
                        return [2 /*return*/, user];
                }
            });
        });
    };
    /**
     * If a valid session currently exists, it will return the current
     * logged-in user data. Otherwise, it will just return null.
     */
    Users.prototype.resumeLogin = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var user, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, adapter_1.adapter.users.resumeLogin()];
                    case 1:
                        user = _a.sent();
                        session_1.session.create(user);
                        this.subscribeForTags(user);
                        return [2 /*return*/, user];
                    case 2:
                        e_1 = _a.sent();
                        session_1.session.destroy();
                        return [2 /*return*/, null];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Version 2
     * If a valid session currently exists, it will return the current
     * logged-in user data. Otherwise, it will just return null.
     *
     * `resumeLoginV2` doesn't subscribe to user tags in websocket,
     * since this is handled by the toolkit service along with CoreX integration
     */
    Users.prototype.resumeLoginV2 = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var user, e_2;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, adapter_1.adapter.users.resumeLoginV2()];
                    case 1:
                        user = _a.sent();
                        session_1.session.create(user);
                        return [2 /*return*/, user];
                    case 2:
                        e_2 = _a.sent();
                        session_1.session.destroy();
                        return [2 /*return*/, null];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Users.prototype.getUserProfile = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var user, e_3;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, adapter_1.adapter.users.getUserProfile()];
                    case 1:
                        user = _a.sent();
                        return [2 /*return*/, user];
                    case 2:
                        e_3 = _a.sent();
                        session_1.session.destroy();
                        return [2 /*return*/, null];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Users.prototype.getUserDocuments = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, adapter_1.adapter.users.getUserDocuments()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    Users.prototype.getUserVerificationURL = function (params) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, adapter_1.adapter.users.getUserVerificationURL(params)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Checks if the current user session is still logged in and valid
     */
    Users.prototype.isLoggedIn = function () {
        return adapter_1.adapter.users.isLoggedIn();
    };
    /**
     * Completes required information for newly registered users via BankID
     */
    Users.prototype.completeRegistration = function (params) {
        return adapter_1.adapter.users.completeRegistration(params);
    };
    /**
     * Resend a users verification email providing
     * they've signed up with an account already and
     * is unverified.
     * @params email The email the user signed up with.
     */
    Users.prototype.resendVerificationEmail = function (email) {
        return adapter_1.adapter.users.resendVerificationEmail({
            email: email,
        });
    };
    /**
     * Signup method calls /users/signUpV2, /users/signUpV2SC or quickSignUpV2 endpoint and returns the user profile
     *
     * @param params
     * @param lang
     * @param [quick] true if no verification required (optional, default false)
     * @param [transparentErrors] true to provide IGC error codes (optional, default false)
     * @param [geoResponse] geo-location response token. required ONLY if the brand has GeoComply enabled
     * @memberof Users
     */
    Users.prototype.signup = function (params, lang, quick, transparentErrors, geoResponse) {
        return adapter_1.adapter.users.signup(params, lang, quick, transparentErrors, geoResponse);
    };
    Users.prototype.signupV2 = function (params) {
        return adapter_1.adapter.users.signupV2(params);
    };
    /**
     * Sends a password reset email to the user in the specified
     * language.
     *
     * @deprecated
     */
    Users.prototype.resetPasswordRequestV1 = function (email, language) {
        return adapter_1.adapter.users.resetPasswordRequestV1({ email: email, lang: language });
    };
    /**
     * Sends a password reset email to the user
     */
    Users.prototype.resetPasswordRequest = function (params) {
        return adapter_1.adapter.users.resetPasswordRequest(params);
    };
    /**
     * Reset password
     */
    Users.prototype.resetPassword = function (password, key) {
        var params = {
            password: password,
            key: key,
        };
        return adapter_1.adapter.users.resetPassword(params);
    };
    /**
     * Sends a request to reset the users password via sms.
     * Used in conjunction with [resetPasswordSMS] to perform the
     * actual reset operation.
     *
     * @param mobilePrefix The calling code
     * @param mobileNumber The mobile number to send the request to
     */
    Users.prototype.sendResetPasswordSMS = function (mobilePrefix, mobileNumber) {
        var params = {
            mobilePrefix: mobilePrefix,
            mobile: mobileNumber,
        };
        return adapter_1.adapter.users.sendResetPwdSMS(params);
    };
    /**
     * Performs a SMS password reset operation. The recovery code is
     * sent to the users mobile via the [sendResetPasswordSMS] method.
     *
     * @param mobilePrefix The calling code
     * @param mobileNumber The mobile number the request was originally sent to
     * @param recoveryCode The OTP recovery code sent to the users mobile
     * @param newPassword The new password the user wishes to use
     */
    Users.prototype.resetPasswordSMS = function (mobilePrefix, mobileNumber, recoveryCode, newPassword) {
        var params = {
            mobilePrefix: mobilePrefix,
            mobile: mobileNumber,
            recoveryCode: recoveryCode,
            password: newPassword,
        };
        return adapter_1.adapter.users.resetPasswordSMS(params);
    };
    /**
     * Change password
     */
    Users.prototype.changePassword = function (oldPassword, newPassword, verificationCode) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var params, result, error_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = {
                            oldPassword: oldPassword,
                            newPassword: newPassword,
                            verificationCode: verificationCode,
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 6]);
                        return [4 /*yield*/, adapter_1.adapter.users.changePassword(params)];
                    case 2:
                        result = _a.sent();
                        return [2 /*return*/, result];
                    case 3:
                        error_1 = _a.sent();
                        if (!(error_1 === API_ERRORS.INVALID_VERIFICATION_CODE &&
                            !verificationCode)) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.sendSMS()];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [2 /*return*/, Promise.reject(error_1)];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Send a verification SMS to an unverified user using mobile prefix and mobile combination.
     * The SMS language is selected using the user's registered LanguageID property.
     * Sends SMS even though user is blocked.
     */
    Users.prototype.verifySMS = function (mobile, mobileVerificationCode, mobilePrefix) {
        var params = {
            Mobile: mobile,
            MobileVerificationCode: mobileVerificationCode,
            MobilePrefix: mobilePrefix,
        };
        return adapter_1.adapter.users.verifySMS(params);
    };
    /**
     * Gets the available consents for the site for non-authenticated users.
     *
     * @see getUserConsents = To get consent acceptance for a particular user
     */
    Users.prototype.getConsents = function (lang) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var consents;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, adapter_1.adapter.users.getConsents({
                            languageAlpha2Code: lang,
                        })];
                    case 1:
                        consents = _a.sent();
                        return [2 /*return*/, consents.map(function (consent) { return (tslib_1.__assign(tslib_1.__assign({}, consent), { consented: consent.consented || false, consentContents: consent.consentContents.find(function (_a) {
                                    var languageAlpha2Code = _a.languageAlpha2Code;
                                    return languageAlpha2Code === lang;
                                }) })); })];
                }
            });
        });
    };
    /**
     * Gets the available consents for the particular user with
     * their acceptance status.
     *
     * @see getConsents = To get the site consents before logged in.
     */
    Users.prototype.getUserConsents = function (lang) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var consents;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, adapter_1.adapter.users.getUserConsents({
                            languageAlpha2Code: lang,
                        })];
                    case 1:
                        consents = _a.sent();
                        return [2 /*return*/, consents.userConsents.map(function (consent) { return (tslib_1.__assign(tslib_1.__assign({}, consent), { consented: consent.consented || false, consentContents: consent.consentContents.find(function (_a) {
                                    var languageAlpha2Code = _a.languageAlpha2Code;
                                    return languageAlpha2Code === lang;
                                }) })); })];
                }
            });
        });
    };
    Users.prototype.detailsUpdateRequested = function () {
        return adapter_1.adapter.users.detailsUpdateRequest();
    };
    /**
     * Saves the consents of the user, if the onsite marketing consent
     * is given then `setUserOnSiteMarketing` is automatically called
     * with the required information.
     */
    Users.prototype.saveUserConsents = function (userConsents, userName, userId) {
        if (userId && !userName) {
            throw new Error('Must supply username if supplying user ID');
        }
        var promises = [
            adapter_1.adapter.users.saveUserConsents({
                userConsents: userConsents,
                userId: userId,
            }),
        ];
        var onsiteConsent = userConsents.find(function (_a) {
            var name = _a.name;
            return name === userPendingConsents_1.ConsentName.ONSITE_MARKETING;
        });
        if (onsiteConsent) {
            promises.push(this.setUserOnSiteMarketing(onsiteConsent.consented, userName));
        }
        return Promise.all(promises).then(function (_a) {
            var _b = tslib_1.__read(_a, 1), saveCall = _b[0];
            return saveCall;
        });
    };
    /**
     * Updates the user profile on CoreX
     */
    Users.prototype.updateUserProfile = function (params) {
        return adapter_1.adapter.users.updateUserProfile(params);
    };
    /**
     * Save the user on site marketing consent in magic. Different
     * to the GiG Core consents. This method is called automatically
     * when `saveUserConsents` is called with the onsite marketing
     * consent given.
     * @param isOnsiteMarketingAllowed Whether or not onsite marketing to this user is allowed
     * @param [userName] The username to set the consent on or empty for current user.
     */
    Users.prototype.setUserOnSiteMarketing = function (isOnsiteMarketingAllowed, userName) {
        var user = session_1.session.getUser();
        if (!user && !userName) {
            throw new Error('User not logged in or no userName given to setUserOnSiteMarketing call.');
        }
        return adapter_1.adapter.users.setUserOnSiteMarketing({
            userName: userName || user.userName,
            notOnSiteMarketing: !isOnsiteMarketingAllowed,
        });
    };
    /**
     * Changes the users email if the password matches the users current
     * password.
     */
    Users.prototype.changeEmail = function (newEmail, password, lang) {
        return adapter_1.adapter.users.changeEmail({
            email: newEmail,
            password: password,
            lang: lang,
        });
    };
    /**
     * Immediately closes the users account.
     * Note: You must end the session with a call to logout.
     */
    Users.prototype.closeAccount = function (currentPassword) {
        return adapter_1.adapter.users.closeAccount({ currentPassword: currentPassword });
    };
    /**
     * Immediately closes the users account. The session is automatically
     * closed afterwards.
     */
    Users.prototype.closeAccountV2 = function (params) {
        return adapter_1.adapter.users.closeAccountV2(params);
    };
    Users.prototype.closeAccountCorex = function (params) {
        return adapter_1.adapter.users.closeAccountCorex(params);
    };
    /**
     * Checks if the email is available to register
     * with.
     */
    Users.prototype.isEmailAvailable = function (email) {
        return adapter_1.adapter.users.isEmailAvailable({ email: email });
    };
    /**
     * Checks if the username is available to register
     * with.
     */
    Users.prototype.isUsernameAvailable = function (username) {
        return adapter_1.adapter.users.isUsernameAvailable({ username: username });
    };
    /**
     * Increments the user achievement count
     */
    Users.prototype.bonus = function (userName, slug, amount) {
        var params = { userName: userName, slug: slug, betAmount: amount };
        return adapter_1.adapter.users.bonus(params);
    };
    /**
     * Lists all user questionnaires
     */
    Users.prototype.getUserQuestionnaires = function (params) {
        return adapter_1.adapter.users.getUserQuestionnaires(params);
    };
    Users.prototype.getQuestionnaireTemplate = function (params) {
        return adapter_1.adapter.users.getQuestionnaireTemplate(params);
    };
    Users.prototype.getSubmitQuestionnaire = function (params) {
        return adapter_1.adapter.users.getSubmitQuestionnaire(params);
    };
    /**
     * Get source of wealth questionnaire
     */
    Users.prototype.getSOWQ = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = util_1.normalize;
                        return [4 /*yield*/, adapter_1.adapter.users.getSOWQ()];
                    case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()]).sowQuestions.map(function (question) {
                            return {
                                id: question.id,
                                type: question.sowQuestionType,
                                answers: question.sowAnswers.map(function (answer) { return ({
                                    id: answer.id,
                                    answer: answer.text,
                                }); }),
                                question: question.text,
                            };
                        })];
                }
            });
        });
    };
    /**
     * Get AML verification status
     */
    Users.prototype.getAmlVerificationStatus = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var verificationStatus;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, adapter_1.adapter.users.getAmlVerificationStatus()];
                    case 1:
                        verificationStatus = _a.sent();
                        return [2 /*return*/, {
                                sowQuestionnaireStatus: verificationStatus.SOWQ || getAmlVerificationStatus_1.DocumentStatus.NOT_REQUESTED,
                                // if verificationStatus.SOWD is null, keep it null. Otherwise,
                                // replace all of its null values with DocumentStatus.NOT_REQUESTED
                                sowDocumentsStatus: verificationStatus.SOWD &&
                                    Object.entries(verificationStatus.SOWD).reduce(function (prev, _a) {
                                        var _b;
                                        var _c = tslib_1.__read(_a, 2), key = _c[0], val = _c[1];
                                        return (tslib_1.__assign(tslib_1.__assign({}, prev), (_b = {}, _b[key] = val || getAmlVerificationStatus_1.DocumentStatus.NOT_REQUESTED, _b)));
                                    }, {}),
                                sofStatus: verificationStatus.SOF || getAmlVerificationStatus_1.DocumentStatus.NOT_REQUESTED,
                                address: verificationStatus.address,
                                payment: verificationStatus.payment,
                                photoID: verificationStatus.photoID,
                                uploadCounter: verificationStatus.uploadCounter,
                                uploadLimit: verificationStatus.uploadLimit,
                                status: verificationStatus.status,
                                bankIdBlocked: verificationStatus.bankIdBlocked,
                                userName: verificationStatus.userName,
                                id: verificationStatus.id,
                            }];
                }
            });
        });
    };
    Users.prototype.getGracePeriods = function () {
        return adapter_1.adapter.users.getGracePeriod();
    };
    /**
     * Get user's preferences
     */
    Users.prototype.getPreferences = function () {
        return adapter_1.adapter.users.getPreferences();
    };
    /**
     * Get reality check options
     */
    Users.prototype.getRealityCheckOptions = function () {
        return adapter_1.adapter.users.getRealityCheckOptions();
    };
    /**
     * Gets a list of information relating to the previous
     * logins the user has made.
     * @param limit The amount of results to fetch
     */
    Users.prototype.getLoginHistory = function (limit) {
        return adapter_1.adapter.users.getLoginHistory({ limit: limit });
    };
    /**
     * Check if the user has pending consents
     */
    Users.prototype.hasPendingConsents = function () {
        return adapter_1.adapter.users.hasPendingConsents();
    };
    /**
     * Get user's pending consents
     */
    Users.prototype.userPendingConsents = function (languageAlpha2Code) {
        var params = { languageAlpha2Code: languageAlpha2Code };
        return adapter_1.adapter.users.userPendingConsents(params);
    };
    /**
     * Set user's preferences
     */
    Users.prototype.setPreferences = function (params) {
        return adapter_1.adapter.users.setPreferences(params);
    };
    /**
     * Set reality check value
     */
    Users.prototype.setRealityCheck = function (value) {
        var params = { value: value };
        return adapter_1.adapter.users.setRealityCheck(params);
    };
    /**
     * Verify user's email
     */
    Users.prototype.verifyEmail = function (token, lang, geoResponse) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var params, user;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = { key: token, geoResponse: geoResponse, lang: lang };
                        return [4 /*yield*/, adapter_1.adapter.users.verifyEmail(params)];
                    case 1:
                        user = _a.sent();
                        session_1.session.create(user);
                        return [2 /*return*/, user];
                }
            });
        });
    };
    /**
     * Get reality check value
     */
    Users.prototype.getRealityCheck = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var res;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, adapter_1.adapter.users.getRealityCheck()];
                    case 1:
                        res = _a.sent();
                        if (res && res.value) {
                            return [2 /*return*/, res.value];
                        }
                        return [2 /*return*/, null];
                }
            });
        });
    };
    /**
     * Get reality check value
     */
    Users.prototype.continueRealityCheckCoreX = function (params) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, adapter_1.adapter.users.continueRealityCheckCoreX(params)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Stop the reality check
     */
    Users.prototype.stopRealityCheckCoreX = function (params) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, adapter_1.adapter.users.stopRealityCheckCoreX(params)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    Users.prototype.getPendingRealityCheckCoreX = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, adapter_1.adapter.users.getPendingRealityCheckCoreX()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get session turnover
     */
    Users.prototype.sessionTurnover = function () {
        return adapter_1.adapter.users.sessionTurnover();
    };
    /**
     * Set user's source of wealth questionnaire
     */
    Users.prototype.postSOWQ = function (params) {
        return adapter_1.adapter.users.postSOWQ({
            SowQuestions: params.questions.map(function (_a) {
                var questionId = _a.questionId, answerIds = _a.answerIds;
                return ({
                    SowQuestionId: questionId,
                    SowAnswerIds: answerIds,
                });
            }),
        });
    };
    /**
     * Impersonate user by passing the IGC session token
     */
    Users.prototype.impersonate = function (token) {
        return adapter_1.adapter.users.impersonate(token);
    };
    /**
     * Get the available ID types
     */
    Users.prototype.getIdDocTypes = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var res;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, adapter_1.adapter.users.getIdDocTypes()];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, Object.keys(res).map(function (key) {
                                return { name: key, id: res[key] };
                            })];
                }
            });
        });
    };
    /**
     * Get user's AML status
     */
    Users.prototype.getAmlStatus = function () {
        return adapter_1.adapter.users.getAmlStatus();
    };
    /**
     * Upload user's KYC documents
     */
    Users.prototype.uploadKYC = function (params, requestDocs) {
        if (requestDocs === void 0) { requestDocs = false; }
        if (requestDocs) {
            return adapter_1.adapter.users.requestAndUploadKYC(params);
        }
        return adapter_1.adapter.users.uploadKYC(params);
    };
    Users.prototype.getPepDetails = function () {
        return adapter_1.adapter.users.getPepDetails();
    };
    Users.prototype.savePepDetails = function (params) {
        return adapter_1.adapter.users.savePepDetails(params);
    };
    /**
     * Update the user's language
     */
    Users.prototype.updateLanguage = function (lang) {
        return adapter_1.adapter.users.updateLanguage(lang);
    };
    /**
     * Unsubscribe the given user for user's tags
     */
    Users.prototype.unsubscribeFromTags = function (user) {
        var tags = this.getUserTags(user);
        adapter_1.adapter.users.unsubscribe({ tags: tags });
    };
    /**
     * Requests a player's KYC documents individually
     */
    Users.prototype.kycDocumentRequest = function (documentType) {
        var params = { documentType: documentType };
        return adapter_1.adapter.users.kycDocumentRequest(params);
    };
    /**
     * Verify user driving licence details with DataZoo
     */
    Users.prototype.verifyWithDataZoo = function (params) {
        return adapter_1.adapter.users.verifyWithDataZoo(params);
    };
    Users.prototype.subscribeForTags = function (user) {
        var tags = this.getUserTags(user);
        adapter_1.adapter.users.subscribe({ tags: tags });
    };
    Users.prototype.getUserTags = function (user) {
        return util_2.getUserTags(user, transport_1.transport.isCoreX(), transport_1.transport.getBrand());
    };
    /**
     * List security question
     */
    Users.prototype.listSecurityQuestions = function () {
        return adapter_1.adapter.users.listSecurityQuestions().then(util_1.normalize);
    };
    /**
     * Change security questions
     */
    Users.prototype.changeSecurityQuestion = function (params) {
        return adapter_1.adapter.users.changeSecurityQuestion(params);
    };
    /**
     * Get user choosed question giving the email
     */
    Users.prototype.getSecurityQuestion = function (email) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var questions;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, adapter_1.adapter.users.getSecurityQuestions({ email: email })];
                    case 1:
                        questions = _a.sent();
                        return [2 /*return*/, questions[0]];
                }
            });
        });
    };
    /**
     * Gets the active blocks applied to the current user.
     */
    Users.prototype.getUserActiveBlocks = function () {
        return adapter_1.adapter.users.getUserActiveBlocks();
    };
    /**
     * Gets the KYC verfication URL.
     */
    Users.prototype.getKycVerificationUrl = function () {
        return adapter_1.adapter.users.getKycVerificationUrl();
    };
    /**
     * Sends a notification email to the user with the specified notification type and content.
     * if content contains HTML tags, the isHTML flag has to be set to true.
     * @param notificationType type of notification
     * @param content notification email content
     * @param isHtml true if email content is html
     */
    Users.prototype.notificationMessage = function (notificationType, content, isHtml) {
        var params = { type: notificationType };
        params = isHtml
            ? tslib_1.__assign(tslib_1.__assign({}, params), { contentHTML: content }) : tslib_1.__assign(tslib_1.__assign({}, params), { content: content });
        return adapter_1.adapter.users.notificationMessage(params);
    };
    /**
     * Call IGC linkSlotboxLandBaseUser endpoint which in turns delivers
     * a slack message to the slotbox CS team.
     */
    Users.prototype.linkSlotboxLandBaseUser = function () {
        return adapter_1.adapter.users.linkSlotboxLandBaseUser();
    };
    /**
     * Check which kind of 2FA authentication has enabled the current loggedin user.
     *
     * @returns a string representing the current auth method
     */
    Users.prototype.getAuthenticationMethod = function () {
        return adapter_1.adapter.users.getAuthenticationMethod();
    };
    /**
     * Sets the kind of 2FA authentication for the loggedin user.
     * Boolean true is returned in case of success, false in case the same auth method is
     * already set up.
     * @param authenticationMethod the kind of 2FA authentication method
     * @returns boolean true is returned in case of success, false in case the same auth method is
     * already set up
     */
    Users.prototype.setAuthenticationMethod = function (authenticationMethod) {
        return adapter_1.adapter.users.setAuthenticationMethod({ authenticationMethod: authenticationMethod });
    };
    Users.prototype.getOmniUserDetails = function () {
        return adapter_1.adapter.users.getOmniUserDetails();
    };
    /**
     * Sends an SMS with a verification code to the mobile number associated to the current authenticated user
     * @returns boolean representing the operation outcome
     */
    Users.prototype.sendSMS = function () {
        return adapter_1.adapter.users.sendSMS();
    };
    /**
     * Gets the game session summary needed for LOTBA regulation
     */
    Users.prototype.getGameSessionSummary = function () {
        return adapter_1.adapter.users.getGameSessionSummary();
    };
    /**
     * Linking accounts for aspers land based user
     */
    Users.prototype.linkLandBased = function () {
        return adapter_1.adapter.users.linkLandBased();
    };
    /**
     * Register a player with a number for UKGC regulation
     */
    Users.prototype.registerMembership = function (params) {
        return adapter_1.adapter.users.membershipRegistration(params);
    };
    /**
     * Get AGCO  user details
     */
    Users.prototype.getAGCODetails = function () {
        return adapter_1.adapter.users.getAGCODetails();
    };
    /**
     * Get the profile from Magic for a CoreX user
     */
    Users.prototype.getMagicProfileCoreX = function () {
        return adapter_1.adapter.users.getMagicProfileCoreX();
    };
    /**
     * Get the reality check config for a CoreX user
     */
    Users.prototype.getUserRealityCheckConfigs = function () {
        return adapter_1.adapter.users.getUserRealityCheckConfigs();
    };
    /**
     * Sets the reality check for a CoreX user
     */
    Users.prototype.setUserRealityCheckInterval = function (params) {
        return adapter_1.adapter.users.setUserRealityCheckInterval(params);
    };
    /**
     * Get the user transactions history for CoreX
     */
    Users.prototype.getUserTransactionsHistory = function (params) {
        return adapter_1.adapter.users.getUserTransactionsHistory(params);
    };
    /**
     * Get the user purchase history for SweepX
     */
    Users.prototype.getSweepxTransactionsHistory = function (params) {
        return adapter_1.adapter.users.getSweepxTransactionsHistory(params);
    };
    /**
     * Get the user bonuses transactions history for CoreX
     */
    Users.prototype.getUserBonusesTransactionsHistory = function (params) {
        return adapter_1.adapter.users.getUserBonusesTransactionsHistory(params);
    };
    Users.prototype.getMailInCode = function () {
        return adapter_1.adapter.users.getMailInCode();
    };
    Users.prototype.getTotalRedemptionAmount = function () {
        return adapter_1.adapter.users.getTotalRedemptionAmount();
    };
    Users.prototype.cancelRedeemSweepcoins = function () {
        return adapter_1.adapter.users.cancelRedeemSweepcoins();
    };
    Users.prototype.resendUserVerification = function (userId, type) {
        return adapter_1.adapter.users.resendUserVerification({
            userId: userId,
            type: type,
        });
    };
    return Users;
}());
exports.users = new Users();
